<script lang="ts">
    import { onMount } from "svelte";
    import { fade } from "svelte/transition";
    import Column from "../materialize/grid/Column.svelte";
    import Row from "../materialize/grid/Row.svelte";
    import LoadingScreen from "./subcomponents/LoadingScreen.svelte";
    import SingleSearchResult from "./subcomponents/SingleSearchResult.svelte";
    import WordSearchModalPopup from "./subcomponents/WordSearchModalPopup.svelte";
    import {
        current_expanded_result_id,
        languages,
        current_dialect,
        is_online,
    } from "../stores/stores";
    import { Word } from "../dictionary/Word";
    import { get_host } from "../settings";
    import WordSearchForm from "./subcomponents/WordSearchForm.svelte";
    import Panel from "../materialize/components/Panel.svelte";
    import { is_desktop_mediaquery } from "../settings";
    import SuggestTranslation from "./subcomponents/SuggestTranslation.svelte";
import Center from "../materialize/grid/Center.svelte";
    let is_desktop: boolean;
    let mediaquery = is_desktop_mediaquery;
    mediaquery.addEventListener("change", () => {
        is_desktop = !mediaquery.matches;
    });
    is_desktop = !mediaquery.matches;

    export let params;

    let search_promise;
    $current_dialect = $languages.find((el) => el.id == params.pk_language);
    $: current_search_word = params.word;
    function retrieve_results(word: string) {
        return fetch(
            get_host() +
                `/api/dictionary/word/search?preferred_dialect=${
                    $current_dialect.id
                }&word=${encodeURIComponent(word)}`
        )
            .then((r) => r.json())
            .then((arr) => {
                search_results = [];
                arr.forEach((el) => {
                    search_results.push(new Word(el));
                });
                search_results = search_results;

                let exactly_matching_word = search_results.find(
                    (el) =>
                        el.word.toLocaleLowerCase() == word.toLocaleLowerCase()
                );
                if (exactly_matching_word !== undefined) {
                    $current_expanded_result_id = exactly_matching_word.id;
                }
            })
            .catch(() => {
                $is_online = false;
            });
    }

    $: {
        search_promise = retrieve_results(current_search_word);
    }
    let search_results: Word[] = [];

    $: search_results_exact = search_results.filter(
        (el) =>
            el.word.toLocaleLowerCase() ===
            current_search_word.toLocaleLowerCase()
    );
    $: search_results_similar = search_results.filter(
        (el) =>
            el.word.toLocaleLowerCase() !==
            current_search_word.toLocaleLowerCase()
    );
</script>

{#if is_desktop}
    <Panel>
        <WordSearchForm />
    </Panel>
{/if}

<Row>
    <Column>
        <h5>
            Ricerca di "{current_search_word}" in {$current_dialect.name.toLocaleLowerCase()}:
        </h5>
    </Column>
</Row>
{#await search_promise}
    <LoadingScreen />
{:then response}
    <div transition:fade>
        {#if search_results_exact.length > 0}
            <h4>Corrispondenza esatta</h4>
            <Row>
                {#each search_results_exact as word}
                    <Column
                        small={12}
                        medium={$current_expanded_result_id === word.id
                            ? 12
                            : 6}
                    >
                        <SingleSearchResult {word} />
                    </Column>
                {/each}
            </Row>
        {/if}

        {#if search_results_similar.length > 0}
            {#if search_results_exact.length === 0}
                <Row>
                    <Column>
                        <h5>"{current_search_word}" non trovato</h5>
                    </Column>
                </Row>
                <Row>
                    <Column>
                        <Center>
                            <SuggestTranslation />
                        </Center>
                        
                    </Column>
                </Row>
            {:else}
            {/if}
            <h4>Forse intendevi cercare...</h4>
            <Row>
                {#each search_results_similar as word}
                    <Column
                        small={12}
                        medium={$current_expanded_result_id === word.id
                            ? 12
                            : 6}
                    >
                        <SingleSearchResult {word} />
                    </Column>
                {/each}
            </Row>
        {/if}

        {#if search_results.length === 0}
            <h3>Nessun risultato</h3>
            <Row>
                <Column>
                    <Center>
                        <SuggestTranslation />
                    </Center>
                </Column>
            </Row>
        {/if}
    </div>
{:catch}
    Errore
{/await}



{#if !is_desktop}
    <WordSearchModalPopup />
{/if}


<style>

</style>